import axios from 'axios';
import { environment } from '../environment/environment';

const uploadFilesService = async (formData,categoryId) => {
    try {
        let token = localStorage.getItem('authToken');
        const response = await axios.post(`${environment.apiHostStartPoint}File?categoryId=${categoryId}`,
            formData, {
            headers: {
                'accept': '*/*',
                'Content-Type': 'multipart/form-data',
                'Authorization': `Bearer ${token}`,
            },
        });
        return response.data;
    } catch (error) {
        console.error('Error uploading files:', error);
        throw error;
    }
};

export default uploadFilesService;
